import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  margin: {
    margin: "5px 4px",
    padding: "0 5px",
    width: "100%",
  },
}));